import { SHOPIFY_HEADERS } from "@smartrr/shared/constants";
import { ReqMiddleware } from "@smartrr/shared/req";
import { TypedFrontendVendorApi } from "@smartrr/shared/typedVendorApi/TypedVendorRoutes";
import { getVendorBearerToken, makeBearerTokenHeaderObj } from "@smartrr/shared/utils/authToken";

import { getShopUrlFromGlobals } from "./shopify/getShopUrlFromGlobals";

const middlewares: ReqMiddleware[] = [
  (endpoint, requestConfig) => {
    const shopUrl = getShopUrlFromGlobals();

    return {
      ...requestConfig,
      headers: {
        [SHOPIFY_HEADERS.SHOP_DOMAIN]: shopUrl,
        ...requestConfig.headers,
        ...makeBearerTokenHeaderObj(getVendorBearerToken()),
      } as HeadersInit,
      credentials: "same-origin",
    };
  },
];
export const typedFrontendVendorApi = new TypedFrontendVendorApi(middlewares);
